import CheckboxFilter from "../Common/CheckboxFilter";
import { sellerTypeData } from "../../../../data/category/inputData";

const SellerType = () => {
  return (
    <CheckboxFilter
      filterName={"sellerType"}
      filterData={sellerTypeData}
      title={"Seller Type"}
    />
  );
};
export default SellerType;
